module.exports = __webpack_public_path__ + "img/Anhänger_Tieflader_18t.d4a39995.svg";